import React, { useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import API_CONSTANTS from './../../api-constants'
import { appHeightChanged } from '../../../actions/app-actions'
import { useDispatch } from 'react-redux'


const OrderedTickets = ({ setTransactions, leftMargin, iframeId  }) => {
    const history = useHistory();
    const dispatch = useDispatch()

    const location = useLocation();
    const [buy_tickets, setBuy_tickets] = useState(false)
    const [cancel_tickets, setCancel_tickets] = useState(false)
    const [updatedReservation, setUpdatedReservation] = useState()
    const [selectedItem, setSelectedItem] = useState()

    useEffect(() => {
        dipatchAppHeight()
    })

    function dipatchAppHeight() {

        dispatch(appHeightChanged(iframeId, false))
    }


    // saving membership array in sessionStorage 
    const memberships = location?.state?.memberships
   
    let member_array = []
    for (let i = 0; i < memberships?.length; i++) {
        let orgs = memberships[i].Organizers
        for (let index = 0; index < orgs.length; index++) {

       
        member_array.push({
            customer: JSON.parse(sessionStorage.getItem('login_info'))[0].Name,
            id: memberships[i].BonusNo,
            orgNo: orgs[index].OrgNo,
            name: memberships[i].BonusName,
            points: memberships[i].PointSaldo,
            customerNo: memberships[i].CustomerNo
        })
        }
    }
   
    sessionStorage.setItem('member_arr', JSON.stringify(member_array.filter((obj1, i, arr) =>
        arr.findIndex(obj2 => (obj2.orgNo === obj1.orgNo)) === i
    )))

    const reservations = location?.state?.reservations
    let key = sessionStorage.getItem('key')

    let future_order = []
    let past_order = []

      reservations?.map((item) => {
        let id = moment(item.ArrDate).format('YYYY-MM-DD')
        let td = moment().format('YYYY-MM-DD')

        if (moment(id).isSameOrAfter(moment(td)) && item.CinemaStatus === 0 && item.CinemaKobStatus === 0) {

            future_order.push(item)
        }
        else past_order.push(item)
    })

    function LoadProfile() {
        fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/LoadProfile?key=${key}`, {
            method: "GET",
            headers: {
                'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                'Content-Type': 'application/x-www-form-urlencoded',
            },  
        })
            .then((res) => res.json())
            .then(result => {
          //      console.log(result, 'load profile result')
                if (result.result === 1) {
                    //  localStorage.setItem('key', result.key)
                    history.push('/profile', {
                        login_info: result.login,
                        transaction: result.transactionsPrYear[0],
                        newsgroup: result.Newsgroups,
                        reservations: result.Reservations,
                        memberships: result.Memberships,
                       
                        vouchers: result.Vouchers
                    })
                }             
            })
    }
            
    function buyTicket(item) {
        setBuy_tickets(true)
        setSelectedItem(item)
      //  console.log(item, 'item on tkt clicked')
     
    }

    function cancelTicket(item) {
        setCancel_tickets(true)
        setSelectedItem(item)
    }

    function closeIframe() {
        setBuy_tickets(false)
        setCancel_tickets(false)
        
        //updating reservations
        fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/UpdateReservations?Key=${key}`, {
            method: "GET",
            headers: {
                'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                'Content-Type': 'application/x-www-form-urlencoded',
            },  

        })
            .then((res) => res.json())
            .then(result => {
            //    console.log(result, 'reservation result')
              //  setReservations(result.Reservations)
                let updatedRes = result.Reservations.find((i) => { return i.No === selectedItem.No })
                setUpdatedReservation(updatedRes)
               // console.log(updatedRes, 'updated')
                let year = moment(selectedItem.ArrDate).format('YYYY')
                if (updatedRes.CinemaKobStatus === 1) {
                    fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/UpdateTransactions?Key=${key}&Year=${year}`, {
                        method: "GET",
                        headers: {
                            'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },  

                    })
                        .then(res => res.json())
                        .then(res => {
                           // console.log(res)

                            setTransactions(res.transactionsPrYear[0])

                          
                        })

                }

            })
      


    }

    useEffect(() => {
    if (selectedItem && updatedReservation) {
        const index = reservations.findIndex(obj => obj.No === updatedReservation.No)
        if (index !== -1) {
            reservations.splice(index, 1, updatedReservation)
        }
       
        }
        LoadProfile();
    }, [buy_tickets, cancel_tickets])

   // console.log(reservations, 'RESERVATIONS')
    return (
        <main>
           
            {buy_tickets === true || cancel_tickets === true ?
                <div className='receiptModal' style={{ marginBottom: '100px', left: leftMargin + 'px' }}>
                    <button className='close-receipt' onClick={closeIframe}>X</button>
                    <iframe id='iframe-flow' style={{ marginTop: '100px' }} allow="fullscreen"
                        src={`${API_CONSTANTS.fetchUrl}/kunde-oplysninger?org=${selectedItem.OrgNo}&rid=${selectedItem.rid}&act=${buy_tickets === true ? 'buy':'cancel'}&key=${selectedItem.ResKey}`}
                     
                    >
                
                    </iframe>
                </div>
                : null
            }
            <p className='text'>Bestilte billetter</p>

            {future_order.length ? future_order.map(item => {
                if (item.CinemaKobStatus === 0 && item.CinemaStatus === 0)
                return <div className='ticketContainer'>
                         <img className='movie-img' src={`https://poster.ebillet.dk/${item.PosterLarge}`} />
                        <div className='info-container'>
                       
                        <p className='movie-name'>{item.ArrName.split('-')[1] ? [item.ArrName.split('-')[0], item.ArrName.split('-')[1].split('.')[0]].join('-') : item.ArrName}</p>
                        <p className='undertext'>{item.ArrName.split('-')[1] && item.ArrName.includes('Med') ? item.ArrName.split('-').pop() : ''}</p>
                        <br></br>
                        <p className='movie-info'> <span>Biograf:</span> <label>{item.OrgName}</label>  </p>
                        <p className='movie-info'> <span>Dato:</span> <label>{moment(item.ArrDate).format('DD')}.{moment(item.ArrDate).locale('da').format(' MMMM')}{moment(item.ArrDate).format(' YYYY')}</label>  </p>
                        <p className='movie-info'> <span>Tidspunkt:</span> <label>{moment(item.ArrDate).format('LT')}</label>  </p>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '-15px' }}>
                            <p className='movie-info'> <span>Sal:</span> <label>{item.LocationName}</label>  </p>
                            <button className='buyticket' style={{marginBottom:'10px'}} onClick={() => cancelTicket(item)}>Afbestil  billetter</button>
                        </div>
                       
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '-15px' }}>
                            <p className='movie-info'> <span>Placering:</span> <label>{item.PlacementNice}</label>  </p>
                            <button className='buyticket' onClick={() => buyTicket(item)}>Køb bestilte billetter</button>
                        </div>

                    </div>
                </div>
            }) : null} 
           
         

            {/*{past_order.length && <div className='past-text-container'> <p className='past-ticket-text'>Tidligere bestilte billetter</p>*/}
            {/*</div>}*/}


            {/*<div className='past-tickets-container' >*/}
            {/*    {past_order.length && past_order.map(item => {*/}

            {/*        return <div style={{ display: 'flex', }}>*/}
            {/*            <img width='105px' height='154px' src={`https://poster.ebillet.dk/${item.PosterLarge}`} />*/}
            {/*            <div style={{ width: '300px', padding: '15px 30px' }}>*/}
            {/*                <p className='movie-name'>{item.ArrName.split('-')[1] ? [item.ArrName.split('-')[0], item.ArrName.split('-')[1].split('.')[0]].join('-') : item.ArrName}</p>*/}
            {/*                <p className='undertext'>{item.ArrName.split('-')[1] ? item.ArrName.split('-').pop() : ''}</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}


            {/*    })}*/}
            {/*</div>*/}
          
           
        </main>
    )
}

export default OrderedTickets